import { merge, omit } from 'lodash';

export const deepMergeObjects = <T extends object>(previousData: T, newData: T): T => {
  const deepData = Object.entries(previousData).reduce((acc, [key, value]) => {
    const isObject = typeof value === 'object' && !Array.isArray(value) && !!value;
    const isArrayOfObjects = typeof value?.[0] === 'object' && Array.isArray(value);
    const exists = !!newData[key];

    if (isObject && !isArrayOfObjects && exists) {
      return { ...acc, [key]: merge({}, value, newData[key]) };
    }

    return acc;
  }, {});

  const shallowData = omit(newData, Object.keys(deepData));
  const nextData = merge({}, previousData, deepData);

  return { ...nextData, ...shallowData };
};
